import React, { useRef } from 'react';
import type {
  BasePatcherProps,
  WithPassedPatchableGroupProps
} from './PatchableGroup';
import { TextField, TextFieldProps } from '@mui/material';
import { useInputPatcherControls } from '@/components/patcher/useInputPatcherControls';
import { passthrough } from '@/util';

export type InputPatcherProps = BasePatcherProps &
  Omit<TextFieldProps, keyof BasePatcherProps> & {
    transformValue?: (val?: string) => string | undefined;
  };

const InputPatcherComponent = <T,>({
  /* eslint-disable @typescript-eslint/no-unused-vars */
  name,
  error,
  wrapper,
  patchable,
  loading,
  hideLoadingOverlay,
  transformValue = passthrough,
  sourceType,
  /* eslint-enable @typescript-eslint/no-unused-vars */
  ...restProps
}: WithPassedPatchableGroupProps<T, InputPatcherProps>) => {
  const ref = useRef<HTMLInputElement | null>(null);
  const { instantValue, onBlur, onChange } = useInputPatcherControls({
    name: name,
    externalOnBlur: restProps.onBlur,
    transformValue,
    patchable,
    ref
  });

  return (
    <TextField
      inputRef={ref}
      color="riskNone"
      value={instantValue}
      error={!!error}
      size="small"
      onChange={onChange}
      fullWidth
      {...restProps}
      disabled={restProps.disabled || loading}
      onBlur={onBlur}
      InputProps={{
        ...restProps.InputProps,
        readOnly: patchable?.readOnly
      }}
    />
  );
};

export const InputPatcher = (props: InputPatcherProps) => (
  <InputPatcherComponent {...props} />
);
